import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Form } from "antd";
import { FormContentBlockerFieldTechnicalCriteria } from "./criteria.js";
import { FormContentBlockerFieldTechnicalRules } from "./rules.js";
import { FormContentBlockerFieldTechnicalServices } from "./services.js";
import { FormContentBlockerFieldTechnicalTcfVendors } from "./tcfVendors.js";
import { useFormContentBlocker } from "../../../../../contexts/formContentBlocker.js";
import { useI18n } from "../../../../../contexts/i18n.js";
import { Notices } from "../../../../common/notices.js";
import { FormHeadline } from "../../../headline.js";
import { FormContentBlockerLayout, FormServiceLayout } from "../../../layout.js";
const FormContentBlockerFieldTechnicalCompose = ({ servicesFieldProps, tcfVendorsFieldProps })=>{
    const { __ } = useI18n();
    const { template } = useFormContentBlocker();
    const notices = [
        {
            message: template?.ruleNotice,
            severity: "info"
        }
    ].filter(Boolean).filter(({ message })=>message);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(FormHeadline, {
                offset: FormContentBlockerLayout.labelCol.span,
                children: __("Technical Definition")
            }),
            notices.length > 0 && /*#__PURE__*/ _jsx(Form.Item, {
                wrapperCol: {
                    offset: FormServiceLayout.labelCol.span,
                    span: FormServiceLayout.wrapperCol.span
                },
                style: {
                    marginBottom: 0
                },
                children: /*#__PURE__*/ _jsx(Notices, {
                    notices: notices
                })
            }),
            /*#__PURE__*/ _jsx(FormContentBlockerFieldTechnicalRules, {}),
            /*#__PURE__*/ _jsx(FormContentBlockerFieldTechnicalCriteria, {}),
            /*#__PURE__*/ _jsx(Form.Item, {
                noStyle: true,
                shouldUpdate: (prevValues, nextValues)=>prevValues.criteria !== nextValues.criteria,
                children: ({ getFieldValue })=>{
                    switch(getFieldValue("criteria")){
                        case "services":
                            return /*#__PURE__*/ _jsx(FormContentBlockerFieldTechnicalServices, {
                                ...servicesFieldProps
                            });
                        case "tcfVendors":
                            return /*#__PURE__*/ _jsx(FormContentBlockerFieldTechnicalTcfVendors, {
                                ...tcfVendorsFieldProps
                            });
                        default:
                            return null;
                    }
                }
            })
        ]
    });
};
export { FormContentBlockerFieldTechnicalCompose };
